import React from 'react';

function About() {
  return (
    <div className="page">
      {/* Scope-contained style element for sequential typographic presentation */}
      <style dangerouslySetInnerHTML={{ __html: `
        .page {
          background-color: #0b0f19;
          color: #f8fafc;
          min-height: 100vh;
          font-family: 'Inter', sans-serif;
          padding: 100px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .about-container {
          max-width: 800px;
          width: 100%;
          text-align: left;
        }

        /* Elements start transparent and slide up slightly */
        .animate-item {
          opacity: 0;
          transform: translateY(25px);
          animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }

        /* Explicit execution staggered intervals */
        .brand-title { animation-delay: 0.1s; }
        .brand-intro { animation-delay: 0.25s; }
        .section-mission-title { animation-delay: 0.4s; }
        .section-mission-text  { animation-delay: 0.5s; }
        .section-vision-title  { animation-delay: 0.65s; }
        .section-vision-text   { animation-delay: 0.75s; }

        .brand-title {
          font-size: 3.5rem;
          font-weight: 800;
          margin-bottom: 25px;
          letter-spacing: -0.03em;
          background: linear-gradient(to right, #38bdf8, #2563eb);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .brand-intro {
          font-size: 1.25rem;
          line-height: 1.75;
          color: #cbd5e1;
          margin-bottom: 60px;
          font-weight: 400;
        }

        .about-container h2 {
          font-size: 1.75rem;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 15px;
          letter-spacing: -0.02em;
          position: relative;
          display: inline-block;
        }

        /* Premium highlight accent line under headings */
        .about-container h2::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -4px;
          width: 40px;
          height: 2px;
          background: #38bdf8;
          border-radius: 2px;
        }

        .about-container p {
          font-size: 1.05rem;
          line-height: 1.7;
          color: #94a3b8;
        }

        .vision-block {
          margin-top: 40px;
        }

        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      ` }} />

      <div className="about-container">
        <h1 className="brand-title animate-item">About NirvanaSol</h1>
        
        <p className="brand-intro animate-item">
          NirvanaSol is an enterprise technology firm specializing in next-generation digital architecture. 
          We architect resilient software solutions, design edge-native multi-cloud strategies, and deploy 
          cognitive AI workflows that transform manual business friction into fully automated ecosystem scale.
        </p>

        <div className="mission-block">
          <h2 className="section-mission-title animate-item">Our Mission</h2>
          <p className="section-mission-text animate-item">
            To equip modern enterprises with cognitive intelligence frameworks and elastic software backbones, 
            driving compounding operational growth and permanent technological maturity.
          </p>
        </div>

        <div className="vision-block">
          <h2 className="section-vision-title animate-item">Our Vision</h2>
          <p className="section-vision-text animate-item">
            To define the global frontier of autonomous technical partnerships, serving as the trusted core 
            infrastructure layer where business strategy seamlessly merges with cognitive automation.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;